var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldCheckered = function SvgShieldCheckered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.616 2.356a.75.75 0 0 1 .882.083 11.25 11.25 0 0 0 7.969 2.812l.127.005a.75.75 0 0 1 .627.532 12.75 12.75 0 0 1-9.032 15.938.75.75 0 0 1-.377 0 12.75 12.75 0 0 1-9.03-15.938l.045-.118a.75.75 0 0 1 .708-.419 11.25 11.25 0 0 0 7.969-2.812zM12 3.978a12.75 12.75 0 0 1-7.927 2.784 11.25 11.25 0 0 0 7.928 13.458 11.3 11.3 0 0 0 3.836-1.91 11.25 11.25 0 0 0 4.09-11.548A12.75 12.75 0 0 1 12 3.978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 21V3a.75.75 0 0 1 1.5 0v18a.75.75 0 0 1-1.5 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.5 11.25a.75.75 0 0 1 0 1.5h-17a.75.75 0 0 1 0-1.5z"
  })));
};
export default SvgShieldCheckered;